<template>
  <div class="col-xl-4 xl-100">
    <px-card title="Top products">
      <div class="card-body p-0">
        <template v-if="items.length">
          <div
            class="d-flex align-items-center px-3 py-2 border-bottom"
            v-for="product in items"
            :key="product.title"
          >
            <img
              v-if="product.image"
              :src="product.image"
              width="42"
              height="42"
              class="mr-2"
              style="object-fit:cover;border-radius:6px;"
            />
            <div class="flex-grow-1 mr-2" style="min-width:0;">
              <div class="text-truncate" style="font-weight:600;" :title="product.title">
                {{ product.title }}
              </div>
              <div class="progress mt-1" style="height:5px;">
                <div
                  class="progress-bar"
                  :style="{ width: product.share + '%', backgroundColor: '#4680ff' }"
                ></div>
              </div>
              <small class="text-muted">{{ formatNumber(product.qty) }} sold</small>
            </div>
            <div class="text-right">
              <div>{{ formatMoney(product.revenue, stats.currencySymbol) }}</div>
            </div>
          </div>
        </template>
        <div v-else class="text-center p-4 text-muted">
          No product sales for this store yet.
        </div>
      </div>
    </px-card>
  </div>
</template>

<script>
import { formatMoney, formatNumber } from "../../../utils/store-stats";

export default {
  name: "top-products-list",
  props: {
    stats: { type: Object, required: true }
  },
  computed: {
    items() {
      return this.stats.topProducts || [];
    }
  },
  methods: {
    formatMoney,
    formatNumber
  }
};
</script>

<style></style>
